(function(){
  'use strict';
  const ATLAS={
    r:'https://cdn.shopify.com/s/files/1/0998/5625/3234/files/cmj-original-rings-concepts-20261008.jpg?v=1791483345',
    b:'https://cdn.shopify.com/s/files/1/0998/5625/3234/files/cmj-original-bracelets-concepts-20261008.jpg?v=1791483395',
    n:'https://cdn.shopify.com/s/files/1/0998/5625/3234/files/cmj-original-necklaces-concepts-20261008.jpg?v=1791483407',
    e:'https://cdn.shopify.com/s/files/1/0998/5625/3234/files/cmj-original-earrings-concepts-20261008.jpg?v=1791483445'
  };
  const SIZE='500% 800%';
  function reference(path){
    const m=String(path||'').match(/\/products\/cmj-atelier-([rbne])(\d{2})(?:\/|$)/);
    if(!m||!ATLAS[m[1]])return null;
    const n=Number(m[2]);if(n<1||n>40)return null;
    const i=n-1;
    return{url:ATLAS[m[1]],size:SIZE,position:(i%5*25)+'% '+(Math.floor(i/5)*100/7).toFixed(6)+'%',index:n};
  }
  function annotate(link,data){
    if(!link||!data)return;
    const u=new URL(link.href,location.origin);
    u.searchParams.set('cmj_sprite',data.url);
    u.searchParams.set('cmj_sprite_size',data.size);
    u.searchParams.set('cmj_sprite_position',data.position);
    link.href=u.href;
    link.dataset.cmjSprite=data.url;
    link.dataset.cmjSpriteSize=data.size;
    link.dataset.cmjSpritePosition=data.position;
  }
  function setImage(el,data){
    el.style.backgroundImage='url("'+data.url+'")';
    el.style.backgroundSize=data.size;
    el.style.backgroundPosition=data.position;
    el.style.backgroundRepeat='no-repeat';
    el.style.aspectRatio='1 / 1';
    el.style.backgroundColor='#faf8f3';
  }
  function fixCard(card){
    if(card.dataset.cmjAtlasReady==='1')return;
    const productLink=card.querySelector('.product-card__link[href]');
    if(!productLink)return;
    const ref=reference(new URL(productLink.href,location.origin).pathname);
    if(!ref)return;
    const gallery=card.querySelector('.card-gallery');
    if(!gallery)return;
    const placeholder=gallery.querySelector('.product-card-gallery__title-placeholder');
    if(!placeholder){card.dataset.cmjAtlasReady='1';return;}
    if(placeholder){
      setImage(placeholder,ref);
      placeholder.style.position='relative';
      placeholder.style.padding='0';
      const a=placeholder.querySelector('a');
      if(a){
        const title=card.querySelector('[data-cmj-title]')?.getAttribute('data-cmj-title')||'this jewellery design';
        a.textContent='';
        a.style.cssText='display:block;position:absolute;inset:0;width:100%;height:100%;';
        a.setAttribute('aria-label','View '+title);
      }
    }
    annotate(card.querySelector('a.cmj-design-card-action'),ref);
    card.dataset.cmjAtlasReady='1';
  }
  function fixProductPage(){
    const ref=reference(location.pathname);
    if(!ref)return;
    const aside=document.querySelector('.cmj-design-pdp-action');
    const cta=aside?.querySelector('a[href*="cmj_design="]');
    if(!cta)return;
    annotate(cta,ref);
    if(aside.querySelector('.cmj-atlas-pdp-reference'))return;
    const visual=document.createElement('div');
    visual.className='cmj-atlas-pdp-reference';
    visual.setAttribute('role','img');
    visual.setAttribute('aria-label','Visual reference for the selected CMJ jewellery design');
    visual.style.cssText='flex:0 0 min(180px,28vw);width:min(180px,28vw);';
    setImage(visual,ref);
    aside.prepend(visual);
  }
  function scan(){
    document.querySelectorAll('product-card').forEach(fixCard);
    fixProductPage();
  }
  function boot(){
    scan();
    let pending=false;
    const observer=new MutationObserver(function(){
      if(pending)return;
      pending=true;
      requestAnimationFrame(function(){pending=false;scan();});
    });
    observer.observe(document.body,{childList:true,subtree:true});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
})();